import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import './EnhancedComponents.css';

const Hello = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const [hoursSinceBirth, setHoursSinceBirth] = useState(0);
  const navigate = useNavigate();

  // Calculate hours since December 6, 1974 at 12:34
  useEffect(() => {
    const calculateHours = () => {
      const birthDate = new Date('1974-12-06T12:34:00');
      const now = new Date();
      const diffInMilliseconds = now - birthDate;
      const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
      setHoursSinceBirth(diffInHours);
    };

    // Calculate immediately
    calculateHours();

    // Update every hour
    const interval = setInterval(calculateHours, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleSouthington = () => {
    // Navigate to Southington page
    navigate('/southington');
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  // Split number into individual digits for flip counter effect
  const formatNumberForCounter = (num) => {
    const numStr = num.toLocaleString().replace(/,/g, '');
    return numStr.split('').map((digit, index) => ({
      current: digit,
      next: digit === '9' ? '0' : String(parseInt(digit) + 1),
      key: `${index}-${digit}`
    }));
  };

  return (
    <section id="hello" className="section hello-section">
      <div className="section-header">
        <h1>Ciao</h1>
      </div>
      <div className="hello-content">
        <p className="welcome-text">Welcome to my site! I'm Marco De Marco, and I'm excited to have you here. This site is a celebration of family, heritage, and the things that matter most to me, that I would like to share with you.</p>

        {showMore && (
          <div className="extended-intro">
            <p>From my Italian roots with my tree spanning over 150 years, to my home in Southington, Connecticut, to the simple pleasures of good food, wine, and family traditions - this site tells my story.</p>
            <p>Whether you're here to explore my family history, learn about town, or discover some authentic Italian recipes, I hope you find something that connects with you.</p>
          </div>
        )}
      </div>

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-birthday-cake"></i>{showMore ? 'Less' : 'More About Me'}
        </button>

        <button className="cta-btn secondary" onClick={handleSouthington}>
          <i className="fas fa-heart"></i>I Love Southington
        </button>
      </div>
      
	    <Gallery ref={galleryRef} images={galleryData.hello} sectionName=" " thumbnailSize={300} maxDisplay={4} />

      {/* Mechanical Flip Counter */}
      <div className="click-counter">
        <div className="counter-display">
          <div className="flip-counter">
            {formatNumberForCounter(hoursSinceBirth).map((digit, index) => (
              <div key={digit.key} className="digit-wheel">
                <div className="digit-current">{digit.current}</div>
                <div className="digit-next">{digit.next}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      

    </section>
);
};

export default Hello;
